import React, { useEffect, useState } from 'react';
import { SiteTitle } from "./SiteTitle";
import { FetchData } from "./FetchData";
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';



function Home() {

  useEffect(() => {
    // 檢查用戶是否已經登入，如果已經登入，則不執行後續的登入流程
    const isLoggedIn = localStorage.getItem('login_state') === 'true'; // 假設登入狀態保存為布爾值字符串

    if (isLoggedIn) {
      return;
    }

    // 解析 URL 中的查詢參數
    const queryParams = new URLSearchParams(window.location.search);
    const codeParam = queryParams.get('code');
    console.log(codeParam)
    let apiUrl = `${api_url}/api/Auth/CreateNYCUUser`;

    // 如果存在 code 參數，則將其保存到狀態中
    if (codeParam) {
      const formData = new FormData();
      formData.append('code', codeParam);

      fetch(apiUrl, {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          let arr_status = [String(data.statusCode), data.row, data.detail]; // API 回傳判斷     
          console.log(arr_status[0]);
          switch (arr_status[0]) {
            case "200": //將Token寫入browser
              localStorage.setItem('accessToken', arr_status[1].accessToken); //將Token寫入browser
              localStorage.setItem('refreshToken', arr_status[1].refreshToken);
              localStorage.setItem('login_state', 'true');
              window.location.href = '/';
              break;
            case "400":
              Swal.fire({
                icon: 'error',
                title: `${data.row}`,
                text: arr_status[2]
              });
              break;
            case "401":
              Swal.fire({
                icon: 'error',
                title: '【登入資料不正確】',
                text: arr_status[2]
              });
              break;
            case "403":
              Swal.fire({
                icon: 'error',
                title: '【reCaptcha不正確】',
                text: arr_status[2]
              });
              break;
            case "500":
              window.location.href = '404';
              break;
            default:
          }
        }).finally(() => {
          // this.handleRefreshReCaptcha();
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }
  }, []);



  return (
    <div>
      <SiteTitle />
      <div className="mt-5">
        <h1 id="tableLabel" className='table-title mb-3'>平台公告</h1>
        <FetchData />
      </div>
    </div>
  );
}

export default Home;
